module.exports = __webpack_public_path__ + "img/android-samsung-internet-menu.28c3be84.png";